import { render } from "./CoverPackage.vue?vue&type=template&id=d6c8fc34&scoped=true"
import script from "./CoverPackage.vue?vue&type=script&lang=js"
export * from "./CoverPackage.vue?vue&type=script&lang=js"

import "./CoverPackage.vue?vue&type=style&index=0&id=d6c8fc34&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c8fc34"]])

export default __exports__